import React from 'react';
import { Box, Chip, Drawer, List, Stack, Typography } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import { useActiveMenuItem } from '../../hooks/useActiveMenuItem';
import { menuItems } from '../../types/menuItems';
import MenuItemComponent from './MenuItemComponent';

interface SidebarProps { width: number; open: boolean; onClose: () => void; isMobile: boolean; }

const LeftNavigationBar: React.FC<SidebarProps> = ({ width, open, onClose, isMobile }) => {
    const activePath = useActiveMenuItem();

    return (
        <Drawer variant={isMobile ? 'temporary' : 'permanent'} open={open} onClose={onClose}
            sx={{ width, flexShrink: 0, [`& .MuiDrawer-paper`]: { width, boxSizing: 'border-box', border: 0,
                background: 'radial-gradient(circle at 12% 0%, rgba(226,119,79,.12), transparent 29%), #172b48',
                color: 'white', px: 0, py: 0 } }}>
            <Box component="nav" aria-label="Навигация администратора" sx={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ px: 2.5, pt: 2.5, pb: 2 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <img src="/knopka_main.png" alt="ONE KNOPKA" style={{ width: 142 }} />
                        <Chip size="small" label="ADMIN" sx={{ height: 23, borderRadius: 1, fontSize: 10, letterSpacing: '.08em',
                            bgcolor: 'rgba(226,119,79,.16)', color: '#f0a283', border: '1px solid rgba(226,119,79,.3)' }} />
                    </Stack>
                    <Typography variant="caption" sx={{ display: 'block', mt: 1.25, color: 'rgba(255,255,255,.42)', lineHeight: 1.45 }}>
                        Операционное управление сервисом
                    </Typography>
                </Box>

                <Typography variant="overline" sx={{ px: 3, pt: 1, pb: .75, color: 'rgba(255,255,255,.34)',
                    fontSize: 10, fontWeight: 750, letterSpacing: '.16em' }}>Рабочее пространство</Typography>
                <List disablePadding sx={{ width, pb: 2 }}>
                    {menuItems.map(item => <MenuItemComponent key={item.path} {...item}
                        active={item.path === activePath} onNavigate={isMobile ? onClose : undefined} />)}
                </List>

                <Box sx={{ mt: 'auto', mx: 2, mb: 2, p: 1.75, borderRadius: 2.5,
                    bgcolor: 'rgba(9,21,37,.28)', border: '1px solid rgba(255,255,255,.06)' }}>
                    <Stack direction="row" alignItems="center" gap={1}>
                        <FiberManualRecord sx={{ color: '#65b87a', fontSize: 12 }} />
                        <Typography variant="caption" fontWeight={700}>Система работает</Typography>
                    </Stack>
                    <Typography variant="caption" sx={{ display: 'block', mt: .5, color: 'rgba(255,255,255,.38)' }}>
                        Backend и хранилища подключены
                    </Typography>
                </Box>
            </Box>
        </Drawer>
    );
};

export default LeftNavigationBar;
